class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.header = this.querySelector('header');
    this.scrollThreshold = 0;
    this.scrolled = false;
    this.lastScrollPosition = 0;
    this.handleScroll = this.handleScroll.bind(this);

    window.addEventListener('scroll', this.handleScroll);
  }

  connectedCallback() {
    this.handleScroll(); // Check initial scroll position
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const currentScrollPosition = window.scrollY;

    // Toggle the 'scrolled' class on all screens
    if (currentScrollPosition > this.scrollThreshold) {
      this.header.classList.add('scrolled');
    } else {
      this.header.classList.remove('scrolled');
    }

    // Apply specific scroll effects only on desktop
    if (window.innerWidth >= 768) {
      if (currentScrollPosition > this.lastScrollPosition) {
        // Scrolling down
        this.header.classList.add('nav-hidden');
        this.dispatchEvent(new CustomEvent('headerHidden'));
      } else {
        // Scrolling up
        this.header.classList.remove('nav-hidden');
        this.dispatchEvent(new CustomEvent('headerShown'));
      }
    }

    this.lastScrollPosition = currentScrollPosition;
  }
}

customElements.define('header-menu', HeaderMenu);

class DropdownMenu extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.trigger = this.querySelector('[data-dropdown-trigger]');
    this.content = this.querySelector('[data-dropdown-content]');
    this.activeClass = 'active';
  }

  static get observedAttributes() {
    return ['force-open'];
  }

  connectedCallback() {
    this.trigger.addEventListener('mouseenter', () => this.open());
    this.trigger.addEventListener('mouseleave', (e) => this.handleLeave(e));
    this.content.addEventListener('mouseenter', () => this.open());
    this.content.addEventListener('mouseleave', (e) => this.handleLeave(e));

    // Initial check for force-open
    if (this.hasAttribute('force-open')) {
      this.open();
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'force-open') {
      if (this.hasAttribute('force-open')) {
        this.open();
      } else {
        this.close();
      }
    }
  }

  open() {
    this.isOpen = true;
    this.content.classList.remove('tw-opacity-0', 'tw-invisible', 'tw-translate-y-2');
    this.content.classList.add('tw-opacity-100', 'tw-visible', 'tw-translate-y-0');
    // Add active class to trigger
    this.trigger.classList.add(this.activeClass);
  }

  close() {
    // Don't close if force-open is set
    if (this.hasAttribute('force-open')) return;

    this.isOpen = false;
    this.content.classList.add('tw-opacity-0', 'tw-invisible', 'tw-translate-y-2');
    this.content.classList.remove('tw-opacity-100', 'tw-visible', 'tw-translate-y-0');
    // Remove active class from trigger
    this.trigger.classList.remove(this.activeClass);
  }

  handleLeave(e) {
    const relatedTarget = e.relatedTarget;
    if (!this.contains(relatedTarget)) {
      this.close();
    }
  }

  // Public methods for external control
  forceOpen() {
    this.setAttribute('force-open', '');
  }

  forceClose() {
    this.removeAttribute('force-open');
  }
}

customElements.define('dropdown-menu', DropdownMenu);
